module.exports = __webpack_public_path__ + "assets/images/4-1em2IT_.jpg";